import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
      OVERVIEW: (startDate, endDate, communityId) => {
        if (!startDate || !endDate || !communityId) {
            return null;
        }

        return {
            url: `vervanger/overview?begin=${startDate}&eind=${endDate}&iCommunityId=${communityId}`,
            method: "get",
        };
    },
};

export const useOverview = (
    startDate,
    endDate,
    communityId
) =>
    useApiFetcherSWR(
        API_ENDPOINT.OVERVIEW(
            startDate,
            endDate,
            communityId
        )
    );